<template>
    <div>
        <!-- old -->
        <div class="vip_box"
             v-if="!showNewPage">
      <span class="icon_succ"
            :class="{'icon_fail':status == '0'}"></span>
            <p class="pay_succ">{{title}}</p>
        </div>
        <!-- add -->
        <div class="apply_box"
             v-else>
            <div class="succ_bg"></div>
            <p class="title">订单提交成功</p>
            <p class="info">根据您的资质，已为您匹配其他通过率高的产品</p>
            <p class="btn"
               @click="toProductDetail">前往申请</p>
        </div>
    </div>
</template>

<script>

    export default {
        components: {
            // Head,
        },
        data() {
            return {
                status: '',
                title: '',
                os: localStorage.getItem('os'),
                appVersion: localStorage.getItem('appVersion'),
                scenceCode: 0,//默认为0 等于4时 跳转新页面
                showNewPage: false,//显示新页面
            }
        },
        mounted() {
            this.status = this.$route.query.status;
            this.scenceCode = this.$route.query.scenceCode;
            if (this.scenceCode == 4 || this.scenceCode == 6) {
                this.showNewPage = true;
            } else {
                this.showNewPage = false;
            }
            this.appVersion = localStorage.getItem('appVersion');
            this.os = localStorage.getItem('os');//判断ios老包无法跳转成功页面的bug——老版本ios没有传status导致的
            if (this.os == 2 && parseFloat(this.appVersion) < parseFloat('1.2.0')) {
                this.title = '支付成功'
                this.util.title('支付成功');
            } else {
                if (this.status == 1) {
                    this.title = '支付成功'
                    this.util.title('支付成功');
                } else {
                    this.title = '支付失败'
                    this.util.title('支付失败');
                }
            }
        },
        methods: {
            //调用android和ios的方法
            toProductDetail() {
                var packageName = localStorage.getItem("packageName");
                if (packageName && packageName == 'com.tcb.TCHelp') {
                    this.$router.push({
                        path: "/newpage/recommendPage"
                    });
                } else {
                    let json = {
                        pageUrl: '77xyPrefix/?Page=7&type=1'
                    }
                    try {
                        window.webkit.messageHandlers.toProductDetail.postMessage(json);//ios
                    } catch (err) {
                        window.AppJs.toProductDetail(JSON.stringify(json));//android
                    }
                }
            },
        }

    }
</script>
<style scoped>
    .vip_box {
        text-align: center;
        padding-top: 0.68rem;
        /* box-shadow: 0px 1px 0px 0px rgba(255, 0, 0, 1); */
    }

    .icon_succ,
    .icon_fail {
        display: inline-block;
        width: 1rem;
        height: 1rem;
        margin: 0 auto;
        background: url('../../assets/img/vip/success.png') no-repeat center center;
        background-size: 100% 100%;
    }

    .icon_fail {
        background: url('../../assets/img/vip/fail.png') no-repeat center center;
        background-size: 100% 100%;
    }

    .pay_succ {
        color: #333333;
        font-size: 0.2rem;
    }

    .apply_box {
        background: #ffffff;
        padding: 0.2rem 0 0.33rem 0;
        text-align: center;
    }

    .bg {
        background: #f7f7f7;
        width: 100%;
        height: 0.1rem;
    }

    /* .header {
      padding: 0.2rem 0 0.33rem 0;
      background: #ffffff;
    } */
    .succ_bg,
    .fail_bg {
        width: 1.09rem;
        height: 0.9rem;
        background: url('../../assets/img/afterLoan/success_bg.png') no-repeat top center;
        background-size: 100% 100%;
        margin: 0 auto;
    }

    .fail_bg {
        background: url('../../assets/img/afterLoan/apply_fail.png') no-repeat top center;
        background-size: 100% 100%;
    }

    .title {
        color: #333;
        font-size: 0.16rem;
        text-align: center;
        margin-bottom: 0.12rem;
    }

    .info {
        font-size: 0.12rem;
        color: #ff514a;
        text-align: center;
    }

    .btn {
        width: 2.45rem;
        background: linear-gradient(
                132deg,
                rgba(89, 163, 252, 1) 0%,
                rgba(60, 100, 246, 1) 100%
        );
        box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
        border-radius: 25px;
        text-align: center;
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        padding: 0.13rem 0;
        margin: 0 auto;
        margin-top: 0.4rem;
    }
</style>
